import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { logout } from "../actions/user";
import MyApp from "./component";

const mapStateToProps = state => {
  return {
    isLoggedIn: state.isLoggedIn,
    isFullyLoggedIn: state.isFullyLoggedIn,
    error: state.error,
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
};

const container: React.ComponentClass<any> = connect(
  mapStateToProps,
  mapDispatchToProps
)(MyApp);

export default container;



// WEBPACK FOOTER //
// ./src/my-app/container.tsx